import { type CancelExamEventFormType } from '@exam-center/exam-event-management';
import {
  Button,
  DialogActions,
  DialogContent,
  Divider,
  Form,
  FormButton,
  FormTextarea,
  Text,
} from '@shared/components';
import { FormProvider, type UseFormReturn } from 'react-hook-form';

export interface TemporarilyCloseExamEventFormProps {
  form: UseFormReturn<CancelExamEventFormType>;
  onSubmit: (data: CancelExamEventFormType) => void;
  onClose: () => void;
}

export default function TemporarilyCloseExamEventForm(
  props: Readonly<TemporarilyCloseExamEventFormProps>,
) {
  const { form, onSubmit, onClose } = props;
  const { handleSubmit } = form;

  return (
    <FormProvider {...form}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <Text sx={{ mb: (theme) => theme.spacing(4) }}>
            คุณกำลังจะเปลี่ยนสถานะเป็น{' '}
            <Text variant='body1Semibold' component='span'>
              “ปิดรับสมัครชั่วคราว”
            </Text>
            <br />
            รอบสอบนี้จะไม่เปิดให้สมัครสอบจนกว่าจะกลับมาเปิดรับสมัครอีกครั้ง
          </Text>
          <FormTextarea
            name='reason'
            label='กรุณาระบุสาเหตุที่ปิดรับสมัครชั่วคราว'
            placeholder='กรุณาระบุสาเหตุที่ปิดรับสมัครชั่วคราว'
            required
            minRows={1}
          />
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button color='secondary' variant='outlined' size='large' onClick={onClose}>
            ยกเลิก
          </Button>
          <FormButton size='large' label='ปิดรับสมัครชั่วคราว' />
        </DialogActions>
      </Form>
    </FormProvider>
  );
}
